import type { DaySleep } from '@adhd/shared';
import { SleepChips } from './SleepChips.js';
import { TodayDoses } from './TodayDoses.js';
import type { DailyQuote, DayFace } from '../lib/api.js';

/**
 * The morning face. Release 3 of 2.0 (docs/PRD-2.0.md §2).
 *
 * Three answers, none required: last night in a word, the morning dose (the
 * dose cards already carry Taken / Missed / Skipped and "Change the time",
 * which is the "earlier…" the spec asks for), and the slider above this. A
 * quote, because he said he likes them. Then "Start the day", which goes to
 * the Now face; nothing else is on the screen until he does.
 */
export function FaceMorning({
  day,
  sleep,
  sleepSource,
  onSleep,
  quote,
  onStart,
}: {
  day: string;
  sleep: DaySleep | null;
  sleepSource: DayFace['sleepSource'];
  onSleep: (face: DayFace) => void;
  quote: DailyQuote | null;
  onStart: () => void;
}): JSX.Element {
  return (
    <div className="stack-lg stack face-morning">
      {quote && (
        <blockquote className="quote-line">
          <p className="reading">{quote.text}</p>
          <footer className="faint">— {quote.author}</footer>
        </blockquote>
      )}
      <section className="stack-sm stack">
        <h2 className="face-h">Last night’s sleep</h2>
        <SleepChips day={day} value={sleep} source={sleepSource} onChange={onSleep} />
      </section>
      <TodayDoses />
      {/* The one seam on the morning face (the fixes pass, 13 Oct 2026). */}
      <div className="seam">
        <button type="button" className="linkish" onClick={onStart}>
          Start the day ›
        </button>
        <span className="faint">the slider, the doses, the day so far</span>
      </div>
    </div>
  );
}
